module.exports = __webpack_public_path__ + "static/media/bee.81ee2f5c.png";